
// 根据测试环境区分appid，当前仅支持temp用759
let appID = '759';
let domain = window.location.hostname;
// 改成配置759的可用list，其他domain统一走3
const validAppID759Domains = [
    'aigc-fe-preonline.now.baidu.com',
    'aigc-fe-temp.now.baidu.com'
];
if (process.env.VUE_APP_VERSION === 'dev'
    && domain.startsWith('dev.aigc-')
) {
    domain = domain.replace('dev.aigc-', 'aigc-');
}
// 本地直连预上线/线上（npm run serve:preonline / serve:online）时，由启动脚本显式
// 指定环境，直接用对应环境的 APP_ID（759），不再靠域名推断
const remoteEnv = process.env.VUE_APP_REMOTE_ENV || '';
const isRemoteLocal = remoteEnv === 'preonline' || remoteEnv === 'online';
if (!isRemoteLocal
    && (domain.indexOf('aigc-fe-test.now.baidu.com') >= 0
        || domain.indexOf('aigc-fe-dev.now.baidu.com') >= 0
        || domain.indexOf('aigc-fe-offline.now.baidu.com') >= 0
        || domain.indexOf('aigc-fe-tmp.now.baidu.com') >= 0
        || (
            process.env.VUE_APP_VERSION !== 'online'
            && validAppID759Domains.indexOf(domain) === -1
        ))
) {
    appID = '3';
}

export const APP_ID = appID;

// 用户敏捷调研sdk的appId
export const APP_ID_BASS = 83;

// 线下环境的NODE_ENV也是production，不好区分测试环境与线上环境的编译版本，通过额外参数区分
const isOnline = process.env.VUE_APP_VERSION === 'online';

// token在账号 商业aigc 下，
// 测试环境token: 1cd69b47666b76fea3427f84c4dcf770；
// 线上token: 6cb2dc99b973ab824856edca4e054dd1

export const tongjiToken = !isOnline ? '1cd69b47666b76fea3427f84c4dcf770' : '6cb2dc99b973ab824856edca4e054dd1';
